import { Dispatch } from 'react-redux';
import { AxiosError } from "axios";

import { AuthActionCreators, IApplicationState } from ".";
import { IDutyOfficerSchedule, IDutyOfficerScheduleRequest, IContact } from "../models";

export const ActionTypes = {
    SET_SCHEDULE: "SET_SCHEDULE",
    ADD_TIMESLOTS: "ADD_TIMESLOTS",
    UPDATE_TIMESLOT: "UPDATE_TIMESLOT",
    DELETE_TIMESLOT: "DELETE_TIMESLOT",
    SET_STAFF_LIST: "SET_STAFF_LIST"
}

export interface IDutyOfficerScheduleListResponse {
    data: {
        success: boolean,
        message: string,
        results: IDutyOfficerSchedule[]
    }
}

export interface IDutyOfficerSchedulesResponse {
    data: {
        success: boolean,
        message: string,
        results: IDutyOfficerSchedule[]
    }
}

export interface IDutyOfficerScheduleResponse {
    data: {
        success: boolean,
        message: string,
        results: IDutyOfficerSchedule
    }
}

export interface IStaffListResponse {
    data: {
        success: boolean,
        message: string,
        results: IContact[]
    }
}

export const ActionCreators = {
    getSchedule: (): any => (dispatch: Dispatch<IApplicationState>): Promise<IDutyOfficerScheduleListResponse> => {
        var options = {
            url: __API__ + "/duty-officer-schedule"
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IDutyOfficerScheduleListResponse) => {
                if (response.data.success) {
                    dispatch(ActionCreators.setSchedule(response.data.results));
                }

                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    setSchedule: (list: IDutyOfficerSchedule[]) => {
        return {
            type: ActionTypes.SET_SCHEDULE,
            list
        };
    },
    saveTimeSlots: (requestList: IDutyOfficerScheduleRequest[]) => (dispatch: Dispatch<IApplicationState>): Promise<IDutyOfficerSchedulesResponse> => {
        var options = {
            url: __API__ + "/duty-officer-schedule",
            data: requestList
        };

        return dispatch(AuthActionCreators.apiPost(options))
            .then((response: IDutyOfficerSchedulesResponse) => {
                if (response.data.success) {
                    dispatch(ActionCreators.addTimeSlots(response.data.results));
                }

                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    saveTimeSlot: (request: IDutyOfficerScheduleRequest) => (dispatch: Dispatch<IApplicationState>): Promise<IDutyOfficerScheduleResponse> => {
        var options = {
            url: __API__ + "/duty-officer-schedule",
            data: request
        };

        return dispatch(AuthActionCreators.apiPut(options))
            .then((response: IDutyOfficerScheduleResponse) => {
                if (response.data.success) {
                    dispatch(ActionCreators.updateTimeSlot(response.data.results));
                }

                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    addTimeSlots: (items: IDutyOfficerSchedule[]) => {
        return {
            type: ActionTypes.ADD_TIMESLOTS,
            items
        };
    },
    updateTimeSlot: (item: IDutyOfficerSchedule) => {
        return {
            type: ActionTypes.UPDATE_TIMESLOT,
            item
        };
    },
    removeTimeSlot: (id: number) => (dispatch: Dispatch<IApplicationState>): Promise<IDutyOfficerScheduleResponse> => {
        var options = {
            url: __API__ + "/duty-officer-schedule/" + id
        };

        return dispatch(AuthActionCreators.apiDelete(options))
            .then((response: IDutyOfficerScheduleResponse) => {
                if (response.data.success) {
                    dispatch(ActionCreators.deleteTimeSlot(id));
                }

                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    deleteTimeSlot: (id: number) => {
        return {
            type: ActionTypes.DELETE_TIMESLOT,
            id
        };
    },

    getStaffList: () => (dispatch: Dispatch<IApplicationState>): Promise<IStaffListResponse> => {
        var options = {
            url: __API__ + "/staff"
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IStaffListResponse) => {
                if (response.data.success) {
                    dispatch(ActionCreators.setStaffList(response.data.results));
                }

                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    setStaffList: (list: IContact[]) => {
        return {
            type: ActionTypes.SET_STAFF_LIST,
            list
        }
    }
}

export interface IDutyOfficerScheduleState {
    list: IDutyOfficerSchedule[],
    staffList: IContact[]
}

var initialState: IDutyOfficerScheduleState = {
    list: [],
    staffList: []
};

interface ISetSchedule {
    type: string,
    list: IDutyOfficerSchedule[]
}

interface IAddTimeSlots {
    type: string,
    items: IDutyOfficerSchedule[]
}

interface IUpdateTimeSlot {
    type: string,
    item: IDutyOfficerSchedule
}

interface IDeleteTimeSlot {
    type: string,
    id: number
}

interface ISetStaffList {
    type: string,
    list: IContact[]
}

const setSchedule = (state: IDutyOfficerScheduleState, action: ISetSchedule) => {
    state.list = action.list;
    return state;
}

const addTimeSlots = (state: IDutyOfficerScheduleState, action: IAddTimeSlots) => {
    action.items.forEach(item => {
        state.list.push(item);
    });

    return state;
}

const updateTimeSlot = (state: IDutyOfficerScheduleState, action: IUpdateTimeSlot) => {
    state.list = state.list.map(x => {
        if (x.id == action.item.id)
            return action.item;
        else
            return x;
    });

    return state;
}

const deleteTimeSlot = (state: IDutyOfficerScheduleState, action: IDeleteTimeSlot) => {
    state.list = state.list.filter(x => x.id != action.id);
    return state;
}

const setStaffList = (state: IDutyOfficerScheduleState, action: ISetStaffList) => {
    state.staffList = action.list;
    return state;
}

const createReducer = (initialState: IDutyOfficerScheduleState, handlers: any) => {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = Object.assign({}, state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const handlers = {
    [ActionTypes.SET_SCHEDULE]: setSchedule,
    [ActionTypes.ADD_TIMESLOTS]: addTimeSlots,
    [ActionTypes.UPDATE_TIMESLOT]: updateTimeSlot,
    [ActionTypes.DELETE_TIMESLOT]: deleteTimeSlot,
    [ActionTypes.SET_STAFF_LIST]: setStaffList
};

export const Reducer = createReducer(initialState, handlers);
